// Static profile data for portfolio
export const profileData = {
  fullName: 'Lahiru Dilhara',
  professionalTitle: 'RPA Developer | Software Engineering Undergraduate',
  bio: 'Passionate Automation Developer with Expertise in UiPath',
  location: 'Colombo, Sri Lanka',
  email: 'lahirudilhara08@gmail.com',
  phone: '+9477XXX3XXX',
  github: 'https://github.com/LahiruDCode',
  linkedin: 'https://www.linkedin.com/in/lahiru-dilhara-10365227b/',
  twitter: 'https://x.com/Lahiruu01',
  skills: ['UiPath', 'Python', 'React', 'R', 'Java', 'Kotlin', 'C / C++', 'C#', 'HTML / CSS', 'JavaScript', 'SQL', 'MERN Stack',],
  profilePicture: '/static/profile-photos/default-profile.jpg'
};
